import React from "react"

export default function Container({ children }) {
    return (
        <section className="container">
            {children}
        </section>
    )
}
